import React from 'react';
import { FaArrowLeft, FaShieldAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Section({ title }) {
  return (
    <h2 style={{
      fontFamily: "'Orbitron', sans-serif",
      fontSize: '1rem',
      fontWeight: '700',
      color: '#ffffff',
      letterSpacing: '1px',
      marginTop: '40px',
      marginBottom: '16px',
      paddingBottom: '10px',
      borderBottom: '1px solid rgba(0,212,255,0.2)',
    }}>{title}</h2>
  );
}

function PolicyList({ items }) {
  return (
    <ul style={{ paddingLeft: '0', marginBottom: '24px', listStyle: 'none' }}>
      {items.map((item, i) => (
        <li key={i} style={{
          display: 'flex', alignItems: 'flex-start', gap: '10px',
          marginBottom: '10px', color: 'rgba(255,255,255,0.78)',
          fontSize: '0.95rem', lineHeight: '1.7',
        }}>
          <span style={{
            color: '#E31837', marginTop: '8px', flexShrink: 0,
            background: '#E31837', borderRadius: '50%',
            width: '6px', height: '6px', display: 'inline-block',
          }} />
          {item}
        </li>
      ))}
    </ul>
  );
}

function GeneralPrivacy() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #050a14 0%, #0a1628 100%)',
      color: '#ffffff',
      fontFamily: "'Inter', -apple-system, sans-serif",
      position: 'relative',
    }}>
      <div style={{
        position: 'fixed', inset: 0,
        backgroundImage:
          'linear-gradient(rgba(0,212,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,0.03) 1px, transparent 1px)',
        backgroundSize: '60px 60px',
        pointerEvents: 'none', zIndex: 0,
      }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: '820px', margin: '0 auto', padding: '60px 24px 80px' }}>

        <Link to="/" style={{
          display: 'inline-flex', alignItems: 'center', gap: '8px',
          color: '#00d4ff', textDecoration: 'none', marginBottom: '40px',
          fontWeight: '600', fontSize: '0.88rem', letterSpacing: '1px', textTransform: 'uppercase',
        }}>
          <FaArrowLeft /> Back to Home
        </Link>

        {/* Header */}
        <div style={{ marginBottom: '48px' }}>
          <p style={{
            color: '#00d4ff', fontSize: '0.75rem', fontFamily: "'Orbitron', sans-serif",
            fontWeight: '700', letterSpacing: '5px', textTransform: 'uppercase', marginBottom: '12px',
          }}>Legal Document</p>
          <h1 style={{
            fontFamily: "'Orbitron', sans-serif", fontSize: '2.2rem', fontWeight: '900',
            background: 'linear-gradient(90deg, #ffffff 40%, #00d4ff)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text', marginBottom: '12px', lineHeight: '1.2',
          }}>
            <FaShieldAlt style={{ WebkitTextFillColor: '#00d4ff', fontSize: '1.6rem', verticalAlign: 'middle', marginRight: '14px' }} />
            Company Privacy Policy
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.88rem', letterSpacing: '1px', marginBottom: '8px' }}>
            Last Updated: June 1, 2026
          </p>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem' }}>
            This policy covers <strong style={{ color: 'rgba(255,255,255,0.7)' }}>StopNext Services (Pvt) Ltd</strong> as a company and this website.
            For the <strong style={{ color: '#00d4ff' }}>BookTruck mobile app</strong>, see our{' '}
            <Link to="/privacy" style={{ color: '#00d4ff', textDecoration: 'underline' }}>BookTruck Privacy Policy</Link>.
          </p>
          <div style={{ width: '80px', height: '2px', background: 'linear-gradient(90deg, #00d4ff, #E31837)', marginTop: '20px' }} />
        </div>

        {/* Body */}
        <div style={{ lineHeight: '1.85', color: 'rgba(255,255,255,0.82)' }}>

          <p style={{ marginBottom: '24px' }}>
            <strong style={{ color: '#ffffff' }}>StopNext Services (Pvt) Ltd</strong> ("we", "our", "us"),
            registered and operating in Zimbabwe, is committed to protecting your personal information
            in accordance with the <strong style={{ color: '#00d4ff' }}>Zimbabwe Data Protection Act [Chapter 11:21] (2021)</strong> and
            applicable international best practices. This policy explains how we collect, use, and protect
            information gathered through this website and our general business operations.
          </p>

          <Section title="1. Who We Are" />
          <PolicyList items={[
            <><strong style={{ color: '#fff' }}>Company:</strong> StopNext Services (Pvt) Ltd</>,
            <><strong style={{ color: '#fff' }}>Trading as:</strong> StopNext Services</>,
            <><strong style={{ color: '#fff' }}>Address:</strong> 776 Olive Street, Sunway City, Harare, Zimbabwe</>,
            <><strong style={{ color: '#fff' }}>Email:</strong> <a href="mailto:info@stopnextservices.co.zw" style={{ color: '#00d4ff' }}>info@stopnextservices.co.zw</a></>,
            <><strong style={{ color: '#fff' }}>Phone:</strong> +263 774 790 252 / +263 787 270 066</>,
          ]} />

          <Section title="2. Information We Collect Through This Website" />
          <p style={{ marginBottom: '12px' }}>When you use this website, we may collect:</p>
          <PolicyList items={[
            <><strong style={{ color: '#fff' }}>Contact form submissions:</strong> Your name, email address, phone number, and message when you fill in our contact form.</>,
            <><strong style={{ color: '#fff' }}>Live chat data:</strong> Messages and metadata from conversations initiated via our Tawk.to live chat widget.</>,
            <><strong style={{ color: '#fff' }}>Cookies and usage data:</strong> Technical information such as your IP address, browser type, pages visited, and session duration, collected via cookies to improve your experience.</>,
            <><strong style={{ color: '#fff' }}>Voluntarily provided information:</strong> Any information you choose to share when contacting us by phone, email, or social media.</>,
          ]} />

          <Section title="3. How We Use Your Information" />
          <PolicyList items={[
            'To respond to enquiries submitted through the contact form or live chat.',
            'To provide quotes, consultations, and follow-up on service requests.',
            'To improve the performance and content of this website.',
            'To comply with legal and regulatory obligations under Zimbabwean law.',
            'To send service-related communications (not marketing, unless you opt in).',
          ]} />

          <Section title="4. Legal Basis for Processing (Zimbabwe DPA 2021)" />
          <p style={{ marginBottom: '12px' }}>Under the Zimbabwe Data Protection Act 2021, we process your personal data on the following lawful bases:</p>
          <PolicyList items={[
            <><strong style={{ color: '#fff' }}>Consent:</strong> Where you have given clear consent — e.g., accepting cookies or submitting the contact form.</>,
            <><strong style={{ color: '#fff' }}>Legitimate interests:</strong> To respond to business enquiries and operate our website effectively.</>,
            <><strong style={{ color: '#fff' }}>Legal obligation:</strong> Where processing is necessary to comply with Zimbabwean law.</>,
          ]} />

          <Section title="5. Cookies & Tracking" />
          <p style={{ marginBottom: '12px' }}>This website uses cookies for the following purposes:</p>
          <PolicyList items={[
            <><strong style={{ color: '#fff' }}>Essential cookies:</strong> Required for basic site functionality.</>,
            <><strong style={{ color: '#fff' }}>Live chat (Tawk.to):</strong> Third-party cookies to power our live chat widget. Tawk.to only loads after you accept cookies via our consent banner.</>,
            <><strong style={{ color: '#fff' }}>Font delivery (Google Fonts):</strong> Google's servers deliver fonts used on this site. This may log your IP address per Google's privacy policy.</>,
          ]} />
          <p style={{ marginBottom: '24px' }}>
            You can withdraw cookie consent at any time by clearing your browser storage. Refusing cookies may limit some site features.
          </p>

          <Section title="6. Third-Party Services" />
          <PolicyList items={[
            <><strong style={{ color: '#fff' }}>Tawk.to:</strong> Live chat provider. Data is processed per Tawk.to's privacy policy. Chat data is stored on Tawk.to's servers.</>,
            <><strong style={{ color: '#fff' }}>Netlify:</strong> This website is hosted on Netlify. Contact form submissions are processed and stored by Netlify. See Netlify's privacy policy for details.</>,
            <><strong style={{ color: '#fff' }}>Google Fonts:</strong> Font files are served from Google's CDN. Your IP address may be logged by Google.</>,
          ]} />

          <Section title="7. Data Storage & Security" />
          <p style={{ marginBottom: '24px' }}>
            Contact form data is stored on Netlify's secure servers. Live chat data is stored with Tawk.to.
            We do not store personal data collected from this website on our own servers beyond what is necessary
            for business operations. We use HTTPS encryption across this entire website and apply
            industry-standard security practices to prevent unauthorized access.
          </p>

          <Section title="8. Data Retention" />
          <p style={{ marginBottom: '24px' }}>
            We retain contact form enquiries and chat records for up to <strong style={{ color: '#fff' }}>24 months</strong> from
            the date of submission, or longer where required for legal or accounting purposes.
            You may request deletion at any time.
          </p>

          <Section title="9. Your Rights Under Zimbabwe Data Protection Act 2021" />
          <p style={{ marginBottom: '12px' }}>You have the following rights regarding your personal data:</p>
          <PolicyList items={[
            <><strong style={{ color: '#fff' }}>Right of access:</strong> Request a copy of the personal data we hold about you.</>,
            <><strong style={{ color: '#fff' }}>Right to rectification:</strong> Request correction of inaccurate or incomplete data.</>,
            <><strong style={{ color: '#fff' }}>Right to erasure:</strong> Request deletion of your personal data where there is no legitimate reason for us to continue processing it.</>,
            <><strong style={{ color: '#fff' }}>Right to object:</strong> Object to processing of your personal data in certain circumstances.</>,
            <><strong style={{ color: '#fff' }}>Right to data portability:</strong> Request transfer of your data in a structured, machine-readable format.</>,
          ]} />
          <p style={{ marginBottom: '24px' }}>
            To exercise any of these rights, contact us at{' '}
            <a href="mailto:info@stopnextservices.co.zw" style={{ color: '#00d4ff', textDecoration: 'underline' }}>
              info@stopnextservices.co.zw
            </a>. We will respond within <strong style={{ color: '#fff' }}>30 days</strong>.
          </p>

          <Section title="10. Cross-Border Data Transfers" />
          <p style={{ marginBottom: '24px' }}>
            Some of our third-party service providers (Netlify, Tawk.to, Google) operate outside Zimbabwe.
            Where personal data is transferred internationally, we ensure such transfers are made to countries
            or organisations that maintain adequate data protection standards consistent with the Zimbabwe
            Data Protection Act 2021.
          </p>

          <Section title="11. Children's Privacy" />
          <p style={{ marginBottom: '24px' }}>
            This website is not directed at children under the age of 16. We do not knowingly collect
            personal data from children. If you believe a child has submitted personal data to us,
            please contact us immediately and we will delete it.
          </p>

          <Section title="12. Changes to This Policy" />
          <p style={{ marginBottom: '24px' }}>
            We may update this policy from time to time. Material changes will be communicated via a
            notice on this website. The "Last Updated" date at the top of this page reflects the most recent revision.
          </p>

          <Section title="13. Contact & Complaints" />
          <p style={{ marginBottom: '12px' }}>For any privacy-related enquiries or to lodge a complaint:</p>
          <PolicyList items={[
            <>Email: <a href="mailto:info@stopnextservices.co.zw" style={{ color: '#00d4ff', textDecoration: 'underline' }}>info@stopnextservices.co.zw</a></>,
            <>Address: 776 Olive Street, Sunway City, Harare, Zimbabwe</>,
            <>Phone: +263 774 790 252</>,
          ]} />
          <p style={{ marginBottom: '0', fontSize: '0.88rem', color: 'rgba(255,255,255,0.45)' }}>
            You also have the right to lodge a complaint with the{' '}
            <strong style={{ color: 'rgba(255,255,255,0.65)' }}>Postal and Telecommunications Regulatory Authority of Zimbabwe (POTRAZ)</strong>,
            which oversees data protection matters under the Zimbabwe Data Protection Act 2021.
          </p>

        </div>
      </div>
    </div>
  );
}

export default GeneralPrivacy;
